import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/react-hooks';

import { queryProductByHandle, queryBundleCollectionProducts } from '../Queries';

import Product from '../containers/Product/Product';
import BundleProduct from '../containers/BundleProduct/BundleProduct';
import VirtualGiftCardProduct from '../containers/VirtualGiftCardProduct/VirtualGiftCardProduct';
import Loading from '../components/Loading/Loading';

var ProductPage = function ProductPage(props) {
  return ReactDOM.createPortal(React.createElement(ProductPageLoader, props), document.getElementById('react-product'));
};

var _ref = React.createElement('div', { className: 'loading-wrapper' });

var ProductPageLoader = function ProductPageLoader(props) {
  var _useQuery = useQuery(queryProductByHandle, {
    variables: { handle: props.handle }
  }),
      loading = _useQuery.loading,
      error = _useQuery.error,
      data = _useQuery.data;

  // Queries and sets bundle products
  // skips running the query if no
  // bundle handle is supplied


  var bundleQuery = useQuery(queryBundleCollectionProducts, {
    variables: { handle: props.bundleProductHandle, amount: 10 },
    skip: !props.bundleProductHandle
  });

  var bundleProducts = bundleQuery.data && bundleQuery.data.collectionByHandle ? bundleQuery.data.collectionByHandle.products.edges : [];

  if (loading || bundleQuery.loading || !data.productByHandle || !bundleProducts) return _ref;
  if (error) throw new Error(error);

  if (props.bundleProductHandle) {
    return React.createElement(BundleProduct, {
      addVariantToCart: props.addVariantToCart,
      checkout: props.checkout,
      product: data.productByHandle,
      shipLaterEnabled: props.shipLaterEnabled,
      pdpDiscountSnippet: props.pdpDiscountSnippet,
      isWishlistProduct: props.wishlistProducts.includes(data.productByHandle.title),
      toggleAccountModal: props.toggleAccountModal,
      bundleProducts: bundleProducts,
      bundleProductHandle: props.bundleProductHandle,
      pdpAccordionBnslCopy: props.pdpAccordionBnslCopy,
      pdpReturnCopy: props.pdpReturnCopy,
      shippingTimes: props.shippingTimes,
      lowStockThreshold: props.lowStockThreshold,
      pdpCollectionDiscount: props.pdpCollectionDiscount
    });
  } else if (props.virtualGiftCardHandle) {
    return React.createElement(VirtualGiftCardProduct, {
      addVariantToCart: props.addVariantToCart,
      checkout: props.checkout,
      product: data.productByHandle,
      shipLaterEnabled: props.shipLaterEnabled,
      pdpDiscountSnippet: props.pdpDiscountSnippet,
      isWishlistProduct: props.wishlistProducts.includes(data.productByHandle.title),
      toggleAccountModal: props.toggleAccountModal,
      shippingTimes: props.shippingTimes,
      lowStockThreshold: props.lowStockThreshold,
      pdpReturnCopy: props.pdpReturnCopy,
      pdpAccordionBnslCopy: props.pdpAccordionBnslCopy,
      pdpCollectionDiscount: props.pdpCollectionDiscount
    });
  } else {
    return React.createElement(Product, {
      addVariantToCart: props.addVariantToCart,
      checkout: props.checkout,
      product: data.productByHandle,
      shipLaterEnabled: props.shipLaterEnabled,
      pdpDiscountSnippet: props.pdpDiscountSnippet,
      isWishlistProduct: props.wishlistProducts.includes(data.productByHandle.title),
      toggleAccountModal: props.toggleAccountModal,
      pdpAccordionBnslCopy: props.pdpAccordionBnslCopy,
      pdpReturnCopy: props.pdpReturnCopy,
      shippingTimes: props.shippingTimes,
      lowStockThreshold: props.lowStockThreshold,
      pdpCollectionDiscount: props.pdpCollectionDiscount
    });
  }
};

ProductPage.propTypes = {
  handle: PropTypes.string,
  addVariantToCart: PropTypes.func.isRequired,
  checkout: PropTypes.object.isRequired,
  pdpDiscountSnippet: PropTypes.object.isRequired,
  wishlistProducts: PropTypes.array,
  shipLaterEnabled: PropTypes.bool,
  toggleAccountModal: PropTypes.func.isRequired,
  pdpAccordionBnslCopy: PropTypes.string,
  shippingTimes: PropTypes.object,
  pdpCollectionDiscount: PropTypes.object
};

ProductPageLoader.propTypes = {
  handle: PropTypes.string,
  addVariantToCart: PropTypes.func.isRequired,
  checkout: PropTypes.object.isRequired,
  pdpDiscountSnippet: PropTypes.object.isRequired,
  wishlistProducts: PropTypes.array,
  shipLaterEnabled: PropTypes.bool,
  toggleAccountModal: PropTypes.func.isRequired,
  bundleProductHandle: PropTypes.string,
  pdpReturnCopy: PropTypes.string,
  shippingTimes: PropTypes.object,
  lowStockThreshold: PropTypes.string
};

export default ProductPage;